import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule,HashLocationStrategy, LocationStrategy } from "@angular/common";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { Page404Component } from './page404/page404.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BordroComponent } from './user/bordro/bordro.component';
import { PuantajComponent } from './user/puantaj/puantaj.component';
import { HesapComponent } from './user/hesap/hesap.component';
import { SifreDegistirComponent } from './user/sifre-degistir/sifre-degistir.component';
import { PdfYukleComponent } from './admin/pdf-yukle/pdf-yukle.component';
import { ModalComponent } from './modal/modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import { KullaniciPaneliComponent } from './admin/kullanici-paneli/kullanici-paneli.component';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UpdateModalComponent } from './admin/update-modal/update-modal.component';
import { ResetModalComponent } from './admin/reset-modal/reset-modal.component';
import {  MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { AuthInterceptor } from './services/AuthInterceptor';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MessagemodalComponent } from './admin/messagemodal/messagemodal.component';
import { MessagesComponent } from './messages/messages.component';
import { NotifymodalComponent } from './notifymodal/notifymodal.component'
import { NgxSpinnerModule } from 'ngx-spinner';
import { SpinnermoduleComponent } from './spinnermodule/spinnermodule.component';
import {MatCheckboxModule} from '@angular/material/checkbox';






@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    Page404Component,
    DashboardComponent,
    BordroComponent,
    PuantajComponent,
    HesapComponent,
    SifreDegistirComponent,
    PdfYukleComponent,
    ModalComponent,
    KullaniciPaneliComponent,
    UpdateModalComponent,
    ResetModalComponent,
    MessagemodalComponent,
    MessagesComponent,
    NotifymodalComponent,
    SpinnermoduleComponent,
    
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    CommonModule,
    MatDialogModule,
    FileUploadModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    NgxExtendedPdfViewerModule,
    BrowserModule, 
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatTableModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgxSpinnerModule,
  ],
  exports:[
    CommonModule,
    ReactiveFormsModule,
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },],
  bootstrap: [AppComponent],
  entryComponents:[ModalComponent],
})
export class AppModule { }

